import styled from "styled-components";

import { QUERIES, SPACING } from "../../utils/constants";
import { IconButton } from "../IconButton";
import type { ArrowProps, DotProps } from "./types";
import { BaseButton } from "../Button";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
`;

export const ViewportRow = styled.div`
  position: relative;
`;

export const Viewport = styled.div`
  overflow: hidden;
`;

export const Track = styled.div`
  display: flex;
  gap: ${SPACING.md}px;
  padding-bottom: ${SPACING.xs}px;
  touch-action: pan-y pinch-zoom;
`;

export const Arrow = styled(IconButton)<ArrowProps>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === "left" ? "left: -14px;" : "right: -14px;")}
  transform: translateY(-50%);
  z-index: 1;
  display: none;
  border-radius: 50%;
  border: 1px solid var(--color-border-light);
  background: var(--color-card-background);
  box-shadow: var(--shadow-small);

  &:hover:not(:disabled) {
    background: var(--color-card-background);
    color: var(--color-primary);
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  @media ${QUERIES.tabletLargeAndUp} {
    display: inline-flex;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.sm}px;
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs + SPACING.xxs}px;
`;

export const Dot = styled(BaseButton)<DotProps>`
  width: ${({ $active }) => ($active ? "20px" : "8px")};
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: ${({ $active }) =>
    $active ? "var(--color-primary)" : "var(--color-border)"};
  transition:
    width 0.2s ease,
    background 0.2s ease;
`;

export const PageLabel = styled.span`
  display: none;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-sm);
  color: var(--color-text-muted);

  @media ${QUERIES.tabletLargeAndUp} {
    display: inline;
  }
`;
